
import { useParams } from 'react-router-dom';
import ProductDetailHero from './components/ProductDetailHero';
import ProductFeatures from './components/ProductFeatures';
import ProductSpecifications from './components/ProductSpecifications';
import ComplianceSection from './components/ComplianceSection';
import RelatedProducts from './components/RelatedProducts';
import ProductCTA from './components/ProductCTA';

export default function SprinklerSystemsPage() {
  const { id } = useParams();

  const product = {
    id: 7,
    title: 'Sprinkler Heads & Systems',
    category: 'Fire Suppression Systems',
    brand: 'FlameGuardQA',
    model: 'FG-SPR-01',
    certification: 'UL Listed',
    status: 'Available',
    image: 'https://readdy.ai/api/search-image?query=Professional%20fire%20sprinkler%20heads%20installed%20in%20white%20ceiling%20with%20red%20pipes%20and%20brass%20fittings%2C%20UL%20listed%20sprinkler%20system%20with%20various%20temperature%20ratings%20and%20spray%20patterns%20in%20Qatar%20commercial%20building%20with%20clean%20technical%20installation&width=600&height=600&seq=sprinkler-system-detail&orientation=squarish',
    description: 'High-performance sprinkler heads with varied temperature ratings and spray patterns for maximum coverage. These UL-listed systems provide reliable automatic fire suppression for all building types.'
  };

  const features = [
    'Upright, pendant, and concealed types available',
    'Quick response and standard response models',
    'Brass, chrome, or white finishes',
    'UL and FM approved components',
    'Various K-factors for different applications',
    'Temperature ratings from 57°C to 93°C',
    'Corrosion-resistant materials',
    'Easy installation and maintenance'
  ];

  const specifications = [
    { label: 'Model', value: 'FG-SPR-01' },
    { label: 'Type', value: 'Automatic Fire Sprinkler Head' },
    { label: 'K-Factors', value: '5.6 / 8.0 / 11.2' },
    { label: 'Temperature Ratings', value: '57°C–93°C' },
    { label: 'Response Type', value: 'Quick / Standard' },
    { label: 'Thread Size', value: '1/2" NPT' },
    { label: 'Working Pressure', value: 'Up to 12 bar' },
    { label: 'Coverage Area', value: '9–21 m²' },
    { label: 'Material', value: 'Brass with Glass Bulb' },
    { label: 'Finish Options', value: 'Brass / Chrome / White' },
    { label: 'Certification', value: 'UL, FM, QCDD' },
    { label: 'Warranty', value: '10 Years' }
  ];

  const relatedProducts = [
    {
      id: 8,
      title: 'Fire Pump Sets',
      image: 'https://readdy.ai/api/search-image?query=Industrial%20fire%20pump%20system%20with%20electric%20motor%20and%20control%20panel%2C%20professional%20fire%20suppression%20pump%20equipment%20with%20pressure%20gauges%20and%20QCDD%20certification%20in%20Qatar%20fire%20station&width=300&height=200&seq=fire-pumps-related&orientation=landscape',
      category: 'Pumps',
      compliance: 'NFPA 20 Standard'
    },
    {
      id: 9,
      title: 'Control Valves & Accessories',
      image: 'https://readdy.ai/api/search-image?query=Professional%20fire%20sprinkler%20control%20valves%20and%20butterfly%20valves%20with%20red%20handles%20and%20brass%20fittings%2C%20QCDD%20approved%20flow%20control%20devices%20for%20fire%20suppression%20systems%20with%20technical%20specifications&width=300&height=200&seq=control-valves-related&orientation=landscape',
      category: 'Valves',
      compliance: 'FM Approved'
    },
    {
      id: 13,
      title: 'Fire Hydrant Systems',
      image: 'https://readdy.ai/api/search-image?query=Red%20fire%20hydrant%20system%20with%20hose%20reel%20and%20landing%20valve%20in%20protective%20cabinet%2C%20professional%20fire%20fighting%20equipment%20with%20QCDD%20approval%20in%20Qatar%20commercial%20building&width=300&height=200&seq=hydrant-system-related&orientation=landscape',
      category: 'Hydrants',
      compliance: 'BS Standards'
    },
    {
      id: 1,
      title: 'Fire Alarm Control Panel',
      image: 'https://readdy.ai/api/search-image?query=Professional%20intelligent%20fire%20alarm%20control%20panel%20with%20digital%20LCD%20display%20and%20red%20indicator%20lights%2C%20advanced%20addressable%20fire%20detection%20system%20with%20network%20connectivity%20and%20QCDD%20approval%20certification%20in%20Qatar%20commercial%20building&width=300&height=200&seq=alarm-control-panel-related3&orientation=landscape',
      category: 'Fire Alarms',
      compliance: 'QCDD Approved'
    }
  ];

  return (
    <div className="min-h-screen">
      <ProductDetailHero product={product} />
      <ProductFeatures features={features} />
      <ProductSpecifications specifications={specifications} />
      <ComplianceSection />
      <RelatedProducts products={relatedProducts} />
      <ProductCTA />
      
      {/* Floating WhatsApp Button */}
      <div className="fixed bottom-8 right-8 z-50">
        <a 
          href="https://wa.me/97455544093"
          target="_blank"
          rel="noopener noreferrer"
          className="w-14 h-14 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-2xl hover:shadow-3xl transition-all duration-300 flex items-center justify-center group"
        >
          <i className="ri-whatsapp-line text-2xl group-hover:scale-110 transition-transform"></i>
        </a>
      </div>
    </div>
  );
}
